export var HealthCareDistrict;
(function (HealthCareDistrict) {
    HealthCareDistrict[HealthCareDistrict["Undefined"] = 0] = "Undefined";
    HealthCareDistrict[HealthCareDistrict["HYKServa"] = 1] = "HYKServa";
    HealthCareDistrict[HealthCareDistrict["HUS"] = 2] = "HUS";
    HealthCareDistrict[HealthCareDistrict["EK"] = 3] = "EK";
    HealthCareDistrict[HealthCareDistrict["KYM"] = 4] = "KYM";
    HealthCareDistrict[HealthCareDistrict["PH"] = 5] = "PH";
    HealthCareDistrict[HealthCareDistrict["KYServa"] = 6] = "KYServa";
    HealthCareDistrict[HealthCareDistrict["PS"] = 7] = "PS";
    HealthCareDistrict[HealthCareDistrict["ES"] = 8] = "ES";
    HealthCareDistrict[HealthCareDistrict["IS"] = 9] = "IS";
    HealthCareDistrict[HealthCareDistrict["KS"] = 10] = "KS";
    HealthCareDistrict[HealthCareDistrict["PK"] = 11] = "PK";
    HealthCareDistrict[HealthCareDistrict["OYServa"] = 12] = "OYServa";
    HealthCareDistrict[HealthCareDistrict["PP"] = 13] = "PP";
    HealthCareDistrict[HealthCareDistrict["LP"] = 14] = "LP";
    HealthCareDistrict[HealthCareDistrict["L"] = 15] = "L";
    HealthCareDistrict[HealthCareDistrict["KAI"] = 16] = "KAI";
    HealthCareDistrict[HealthCareDistrict["KP"] = 17] = "KP";
    HealthCareDistrict[HealthCareDistrict["TAYServa"] = 18] = "TAYServa";
    HealthCareDistrict[HealthCareDistrict["P"] = 19] = "P";
    HealthCareDistrict[HealthCareDistrict["EP"] = 20] = "EP";
    HealthCareDistrict[HealthCareDistrict["KH"] = 21] = "KH";
    HealthCareDistrict[HealthCareDistrict["TYKServa"] = 22] = "TYKServa";
    HealthCareDistrict[HealthCareDistrict["V"] = 23] = "V";
    HealthCareDistrict[HealthCareDistrict["VS"] = 24] = "VS";
    HealthCareDistrict[HealthCareDistrict["S"] = 25] = "S";
})(HealthCareDistrict || (HealthCareDistrict = {}));
